// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150706/js/" + chunkId + "." + {"44":"4e20634d","225":"0d10b2f2","481":"b5d2a15d","486":"a12a41bb","770":"6c201f60"}[chunkId] + ".0.3389983208747307.chunk.js";
};